import React, { useEffect, useState } from "react";
import { useSession } from "hooks/useSession";
import { fetchWrapper } from "utils/apiFetch";
import { usePlatformModules } from "Settings/PlatFormUserManagement/PlatformUserAction";

const PlatformUserDashboard = () => {
  const { userid } = useSession();
  const { modules } = usePlatformModules();
  const name = localStorage.getItem("name") || "User";

  return (
    <div className="container-fluid py-3">

      {/* Welcome */}
      <div className="mb-4">
        <h5 className="mb-0">Welcome, {name}</h5>
        <p className="text-muted" style={{ fontSize: 13 }}>
          Platform User Dashboard — you have access to the modules below.
        </p>
      </div>

      {/* Module access cards */}
      <div className="row g-3 mb-4">

        {modules.can_report && (
          <div className="col-sm-6 col-lg-3">
            <div className="card h-100">
              <div className="card-body d-flex align-items-center gap-3">
                <div className="bg-light-info rounded p-2">
                  <i className="ph-duotone ph-chart-bar text-info" style={{ fontSize: 24 }} />
                </div>
                <div>
                  <div className="f-w-600">Reports</div>
                  <div className="text-muted" style={{ fontSize: 12 }}>View & export</div>
                </div>
                <a href="/recharge_reports" className="stretched-link" />
              </div>
            </div>
          </div>
        )}

        {(modules.can_credit || modules.can_debit) && (
          <div className="col-sm-6 col-lg-3">
            <div className="card h-100">
              <div className="card-body d-flex align-items-center gap-3">
                <div className="bg-light-success rounded p-2">
                  <i className="ph-duotone ph-arrows-left-right text-success" style={{ fontSize: 24 }} />
                </div>
                <div>
                  <div className="f-w-600">Credit / Debit</div>
                  <div className="text-muted" style={{ fontSize: 12 }}>
                    {modules.can_credit && modules.can_debit
                      ? "Add credit & debit"
                      : modules.can_credit ? "Add credit" : "Add debit"}
                  </div>
                </div>
                <a href="/credit_debit_report" className="stretched-link" />
              </div>
            </div>
          </div>
        )}

        {modules.can_member_view && (
          <div className="col-sm-6 col-lg-3">
            <div className="card h-100">
              <div className="card-body d-flex align-items-center gap-3">
                <div className="bg-light-warning rounded p-2">
                  <i className="ph-duotone ph-users text-warning" style={{ fontSize: 24 }} />
                </div>
                <div>
                  <div className="f-w-600">Members</div>
                  <div className="text-muted" style={{ fontSize: 12 }}>
                    {modules.can_member_edit ? "View & edit" : "View only"}
                  </div>
                </div>
                <a href="/member_management" className="stretched-link" />
              </div>
            </div>
          </div>
        )}

        {/* Profile card — always visible */}
        <div className="col-sm-6 col-lg-3">
          <div className="card h-100">
            <div className="card-body d-flex align-items-center gap-3">
              <div className="bg-light-secondary rounded p-2">
                <i className="ph-duotone ph-user-circle text-secondary" style={{ fontSize: 24 }} />
              </div>
              <div>
                <div className="f-w-600">Profile</div>
                <div className="text-muted" style={{ fontSize: 12 }}>View settings</div>
              </div>
              <a href="/member_setting_management" className="stretched-link" />
            </div>
          </div>
        </div>

      </div>

      {/* No access state */}
      {!modules.can_report && !modules.can_credit && !modules.can_debit && !modules.can_member_view && (
        <div className="alert alert-warning" style={{ fontSize: 13 }}>
          <i className="ph-duotone ph-warning me-2" />
          No modules have been assigned to your account yet. Contact your administrator.
        </div>
      )}

    </div>
  );
};

export default PlatformUserDashboard;